var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#FDEACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0087 6.52747L18.6797 6.56299L18.9927 25.4728L29.3217 25.4373L29.0087 6.52747Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3596 16.0562C19.2957 12.2101 21.0186 8.79264 23.7173 6.57594C21.6803 4.97749 19.1266 4.01629 16.3583 4.02577C9.80004 4.04823 4.58362 9.45096 4.69422 16.1064C4.80482 22.7618 10.2002 28.1282 16.7584 28.1058C19.5267 28.0963 22.0482 27.1177 24.0318 25.5055C21.2604 23.341 19.4235 19.9023 19.3596 16.0562Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3062 15.8942C43.4168 22.5497 38.2004 27.9524 31.6422 27.9748C28.8739 27.9843 26.3201 27.0231 24.2831 25.4247C27.0148 23.2079 28.7047 19.7906 28.6408 15.9444C28.5769 12.0983 26.7406 8.69311 23.9686 6.49515C25.9522 4.88293 28.4737 3.90435 31.242 3.89486C37.8002 3.8724 43.1962 9.27223 43.3062 15.8942Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.920cecce2c8a2256137e2de30b4d9bcd.svg";
export { ForwardRef as ReactComponent };